import { dropdownMenuItemVariants } from "common/components/ui/DropdownMenu";
import Switch from "common/components/ui/Switch";
import type { ExtraCampaignSettingsSchemaType } from "common/schemas";

interface ExcludeTargetsSettingsProps {
  isDrip: boolean;
  settings: ExtraCampaignSettingsSchemaType;
  setSettings: (settings: ExtraCampaignSettingsSchemaType) => void;
}

export default function ExcludeTargetsSettings({
  isDrip,
  settings,
  setSettings,
}: ExcludeTargetsSettingsProps) {
  return (
    <>
      <label
        htmlFor="excludeActive"
        className={dropdownMenuItemVariants({ variant: "default" })}
      >
        In active campaigns
        <Switch
          size="sm"
          id="excludeActive"
          className="ml-auto"
          color="black"
          checked={settings.exclude_active_targets}
          disabled={isDrip || settings.exclude_previous_targets}
          onCheckedChange={(checked: boolean) => {
            setSettings({ ...settings, exclude_active_targets: checked });
          }}
        />
      </label>
      <label
        htmlFor="excludeTargets"
        className={dropdownMenuItemVariants({ variant: "default" })}
      >
        Previously targeted
        <Switch
          size="sm"
          id="excludeTargets"
          className="ml-auto"
          color="black"
          checked={settings.exclude_previous_targets}
          onCheckedChange={(checked: boolean) => {
            setSettings({
              ...settings,
              exclude_previous_targets: checked,
              exclude_active_targets: checked
                ? true
                : settings.exclude_active_targets,
            });
          }}
        />
      </label>
      <label
        htmlFor="noPfp"
        className={dropdownMenuItemVariants({ variant: "default" })}
      >
        No profile photo
        <Switch
          size="sm"
          id="noPfp"
          color="black"
          className="ml-auto"
          checked={settings.no_pfp}
          onCheckedChange={(checked: boolean) => {
            setSettings({ ...settings, no_pfp: checked });
          }}
        />
      </label>
    </>
  );
}
